import { isJwtExpired } from 'jwt-check-expiration'

export default {
  isLogged (state) {
    if (!state.token) {
      return false
    }
    return !isJwtExpired(state.token)
  },

  isSuperUser (state) {
    return state.user.role === 'superuser'
  },

  isAdmin (state) {
    return state.user && (state.user.role === 'admin' || state.user.role === 'superuser')
  },

  isEditor (state) {
    return state.user && (state.user.role === 'admin' || state.user.role === 'superuser' || state.user.role === 'editor')
  }
}
